import { merge } from 'lodash';
import getStyleObjectWithPseudoState from './getStyleObjectWithPseudoState';

function getBorderColor({ styleObject, customStyleSettings, colorPalette }) {
  const mergedStyleObject = merge({}, styleObject, customStyleSettings);
  if (!mergedStyleObject || !mergedStyleObject.border) {
    return {};
  }
  let { color } = mergedStyleObject.border;
  if (colorPalette && colorPalette[color]) {
    color = colorPalette[color];
  }
  const borderColor = `${color || 'transparent'}`;
  return { borderColor };
}

export default function getBorder(
  styleObject,
  customStyleSettings,
  colorPalette
) {
  const mergedStyleObject = merge({}, styleObject, customStyleSettings);
  if (!mergedStyleObject || !mergedStyleObject.border) {
    return {};
  }
  const { thickness, borderStyle } = mergedStyleObject.border;
  if (!thickness) {
    return {};
  }
  let { color } = mergedStyleObject.border;
  if (colorPalette && colorPalette[color]) {
    color = colorPalette[color];
  }
  const borderWidth = thickness;
  const borderColor = `${color || 'transparent'}`;

  const borderHoverColor = getBorderColor({
    ...getStyleObjectWithPseudoState(styleObject, customStyleSettings, 'hover'),
    colorPalette
  });

  let object;
  if (color) {
    object = {
      borderWidth,
      borderStyle,
      borderColor,
      hover: borderHoverColor
    };
  } else {
    object = {
      borderWidth,
      borderStyle,
      hover: borderHoverColor
    };
  }
  return object;
}
